<template>
  <div class="wrapper">
    <parallax
      class="section page-header header-filter"
      parallax-active="true"
      :style="headerStyle"
    />
    <div class="main main-raised">
      <div class="section profile-content">
        <div class="container">
          <div class="md-layout">
            <div class="md-layout-item md-size-50 md-small-size-100 mx-auto">
              <div class="profile">
                <div class="avatar">
                  <img
                    :src="showImage"
                    alt="Circle Image"
                    class="img-raised rounded-circle img-fluid"
                  >
                </div>
                <div class="name">
                  <h3 class="title mb-0">
                    {{ user.salutation }} {{ user.name }}
                  </h3>
                  <span class="md-caption"><i>{{ user.degree }}</i></span>
                  <h3>{{ displayDisciplines(user.disciplines) }}</h3>
                  <div class="description text-center">
                    <p>
                      {{ displaySpecializations(user.specializations)}}
                    </p>
                  </div>
                  <h5>{{ user.employer }}, {{ user.country_info.name }}</h5>
                </div>
              </div>
            </div>
          </div>
          <div class="profile-tabs">
            <tabs
              :tab-active="1"
              :tab-name="['Experience', 'Specialization', 'Membership', 'Contact']"
              :tab-icon="['work', 'engineering', 'account_circle', 'email']"
              plain
              nav-pills-icons
              color-button="primary"
            >
              <!-- here you can add your content for tab-content -->
              <template slot="tab-pane-1">
                <div class="md-layout">
                  <div
                    class="md-layout-item md-size-60 md-small-size-100 mx-auto"
                  >
                    <p>
                      <b>Professional Working Experience: </b> {{ user.pro_experience_calculated }} <br />
                      <b>Significant Working Experience: </b> {{ user.sw_experience_calculated }} <br />
                    </p>
                    <hr />
                    <div v-html="user.experience"></div>
                  </div>
                </div>
              </template>
              <template slot="tab-pane-2">
                <div class="md-layout">
                  <div
                    class="md-layout-item md-size-60 md-small-size-100 mx-auto"
                    v-html="user.specialization"
                  >
                  </div>
                </div>
              </template>
              <template slot="tab-pane-3">
                <div class="md-layout">
                  <div
                    class="md-layout-item md-size-60 md-small-size-100 mx-auto"
                  >
                    <md-table>
                      <md-table-row>
                        <md-table-head>
                          AER Membership Grade
                        </md-table-head>
                        <md-table-head>
                          ID
                        </md-table-head>
                      </md-table-row>
                      <md-table-row 
                        v-for="grade in user.grades"
                        :key="grade.grade_id"
                        :value="grade"
                      >
                        <md-table-cell>
                          {{ grade.grade }}
                        </md-table-cell>
                        <md-table-cell>
                          #{{ grade.grade_id }}
                        </md-table-cell>
                      </md-table-row>
                    </md-table>
                    <md-table v-if="user.licenses.length">
                      <md-table-row>
                        <md-table-head>
                          Engineering License Issuer
                        </md-table-head>
                        <md-table-head>
                          License Number
                        </md-table-head>
                        <md-table-head>
                          Since
                        </md-table-head>
                      </md-table-row>
                      <md-table-row 
                        v-for="license in user.licenses"
                        :key="license.id"
                        :value="license"
                      >
                        <md-table-cell>
                          {{ license.issuer }}
                        </md-table-cell>
                        <md-table-cell>
                          {{ license.license_id}}
                        </md-table-cell>
                        <md-table-cell>
                          {{ new Date(license.issued_at).getFullYear()}}
                        </md-table-cell>
                      </md-table-row>
                    </md-table>
                  </div>
                </div>
              </template>
              <template slot="tab-pane-4">
                <div class="md-layout">
                  <div
                    class="md-layout-item md-size-60 md-xsmall-size-90 mx-auto"
                    v-if="!submitted"
                  >
                      <md-field>
                        <label>Your Name</label>
                        <md-input required></md-input>
                      </md-field>
                      <md-field>
                        <label>Your E-mail</label>
                        <md-input required></md-input>
                      </md-field>
                      <md-field>
                        <label>Your Contact Number</label>
                        <md-input></md-input>
                      </md-field>
                      <md-field>
                        <label>Your Message to {{ user.fullname }}</label>
                        <md-textarea md-autogrow></md-textarea>
                      </md-field>
                      <md-button
                        md-alignment-right
                        class="md-primary"
                        @click="submitted = true"
                      >Submit</md-button>
                  </div>
                  <div
                    class="md-layout-item md-size-60 md-xsmall-size-90 mx-auto text-center"
                    v-if="submitted"
                  >
                    <p class="title icon icon-success">
                      <md-icon style="font-size: 3rem !important;">check_circle</md-icon>
                    <p>
                    <p>
                      Your message has been sent to <b>{{ user.name }}</b>. 
                    </p>
                  </div>
                </div>
              </template>
            </tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Tabs } from "@/components";
import Mixins from "@/plugins/basicMixins";

export default {
    name: "Engineer",
    components: {
        Tabs
    },
    mixins: [Mixins.HeaderImage],
    bodyClass: "profile-page",
    data() {
      return {
        image: require("@/assets/img/city-profile.jpg"),
        img: require("@/assets/img/no-picture.gif"),
        submitted: false,
        user: {
          salutation: "Mr.",
          image: require("@/assets/img/no-picture.gif"),
          name: "Looi Tink Huey, Alex",
          gender: "male",
          dob: new Date("1985-12-20"),
          country: "my",
          email: "alexlooi@live.com",
          mobile: "+601212341234",
          mheo_id: "62106",
          mheo: "iem",
          mheo_year: "",
          degree: "B.ENG (HONS) ELECTRICAL & ELECTRONIC ENGINEERING",
          degree_year: "2015",
          discipline: "Electrical",
          license: "",
          license_year: "",
          experience_pro: 8,
          experience_works: 8,
          employer: "MALIM CONSULTING ENGINEERS SDN BHD",
          specialisation: "L.V. Electrical Distribution ,  H.V. Electrical Distribution ,  Automation",
          experience: "",
          consent: true
        }
    };
  },
  created() {
    let id = this.$route.params.id;

    this.$store.dispatch("engineers/get", {id: id})
    .then(() => {
      this.user = this.$store.getters["engineers/engineer"];
    });
  },
  computed: {
    showImage() {
      return (this.user.image) ? this.user.image : this.img
    },
  },
  methods: {
    displaySpecializations(list) {
      if ( list.length > 0 ) {
        return Array.prototype.map.call(list, s => s.name).join(", ");
      } 
      return '';
    },
    displayDisciplines(list) {
      if ( list.length > 0 ) {
        return Array.prototype.map.call(list, s => s.name).join(", ");
      }
      return '';
    }
  }
};
</script>

<style lang="scss" scoped>
.section {
  padding: 0;
}

.profile-tabs::v-deep {
  .md-card-tabs .md-list {
    justify-content: center;
  }

  [class*="tab-pane-"] {
    margin-top: 3.213rem;
    padding-bottom: 50px;

    img:not(.img) {
      margin-bottom: 2.142rem;
    }
  }
}
</style>
